<script>
	import { mapState } from 'vuex';
	
	export default{
		data(){
			return {
				file:'',
				type:'',
				steps: [
				{
					target: '[data-v-step="38"]',
					content: `Recuerda que todos los documentos que adjuntes deben ser externos para que el proveedor los pueda visualizar.`,
					params: {
						placement: 'right'
					}
				}
				],
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Aceptar'
					}
				},
			}
		},
		computed:{
			...mapState(['alertas'])
		},
		mounted(){
			window.$('#add-file').on('shown.bs.modal', () => {
				if(this.alertas){
					this.$tours['addFiles'].start();
				}
			});			
		},
		methods:{
			addFile(){
				if(this.file != '' && this.type != ''){
					this.$emit('loadFile',{file: this.file, type: this.type});
					this.file = '';
					this.type = '';
					window.$('#FileModal').val('');
					window.$('#add-file').modal('hide');	
				}
			},
			filesChange(evt){
				this.file = evt.target.value;
			}
		}
	}

</script>
<template>
	<div>
		<v-tour name="addFiles" :steps="steps" :options="myOptions"/>
		<div id="add-file" class="modal fade modal-second" role="dialog">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="header-modal">
						<label>Nueva Solicitud Acuerdo: Paso 4 (Adjuntos)</label>
						<div class="modal-header-buttons">
							<button type="button">
								<i class="far fa-window-maximize"></i>	
							</button>
							<button type="button" data-dismiss="modal" >
								<i class="fas fa-times"></i>	
							</button>
						</div>
					</div>
					<div class="body-modal pb-30">
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<label for="" class="control-label">Nombre Archivo:</label>
									<input id="FileModal" type="file" @change="filesChange($event)">
								</div>
							</div>
							<div class="col-md-12">
								<div class="form-group buttons no-bg" data-v-step="38">
									<label for="" class="control-label i">Tipo de Adjunto:</label>
									<select v-model="type" class="form-control">
										<option value="Externo">Externo</option>
										<option value="Interno">Interno</option>
									</select>
									<button @click="addFile()"><i class="fas fa-file-upload"></i> Cargar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>